import { ScreenField } from 'app/area/codetable/item/screen-renderer/types';
import { CodeActionType } from 'app/area/codetable/item/types';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ValidationProps } from 'ui';

interface InfoText {
  category: CodeComplexValue<number>;
  description: CodeComplexValue<number>[];
  languageValue: number;
}

export const getInfoText = (infoText: InfoText) => {
  const { description, category: { value: categoryValue = undefined } = {}, languageValue } = infoText || {};

  return isDefinedIncludingZero(categoryValue)
    ? description?.find(d => d.value === languageValue)?.description
    : undefined;
};

export const shouldRender = (id: number, item: CodeComplexValue<number>, actionType: CodeActionType) => {
  return actionType !== CodeActionType.Edit || item?.value !== id;
};

export const getFactorFieldIds = (validation: { [key: string]: ValidationProps }) =>
  Object.keys(validation ?? {}).filter(key => key.indexOf(ScreenField.factor) >= 0);
